import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';
import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import {
    almacenarAction
} from '../../../../actions/almacenarEjercicioActions';

import {
    ContainerFlex
} from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    PantallaInferencia,
    ContenidoLEN40,
    MixtaLEN40,
    ImagenLEN40,
    DerechaLEN40,
    FraseLEN40,
    PreguntaTextoLEN40,
    RespuestasLEN40,
    RespuestaLEN40,
    BottomInferencia
} from '../../../Css/StyledInferencia';


const instrucciones =
    'Observá la imagen, leé la oración y elegí la respuesta correcta.';

const miniInstrucciones =
    'Observá la imagen, leé la oración y elegí la respuesta correcta.';


// =============================================================
// MEZCLAR OPCIONES
// =============================================================

const mezclarOpciones = (array) => {

    const nuevaLista = [
        ...array
    ];

    let currentIndex =
        nuevaLista.length;

    let randomIndex;


    while (
        currentIndex !== 0
    ) {

        randomIndex =
            Math.floor(
                Math.random() *
                currentIndex
            );


        currentIndex--;


        [
            nuevaLista[currentIndex],
            nuevaLista[randomIndex]
        ] = [
            nuevaLista[randomIndex],
            nuevaLista[currentIndex]
        ];
    }


    return nuevaLista;
};


const LEN40 = () => {

    const dispatch =
        useDispatch();

    const navigate =
        useNavigate();

    const [config] =
        useConfigAuth();


    // =========================================================
    // EJERCICIO
    // =========================================================

    const [
        count,
        setCount
    ] = useState(1);


    const [
        indexes,
        setIndexes
    ] = useState(0);


    const [
        comparar,
        setComparar
    ] = useState(null);


    const [
        opciones,
        setOpciones
    ] = useState([]);


    const [
        seleccionada,
        setSeleccionada
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    // =========================================================
    // FEEDBACK
    // =========================================================

    const [
        isCorrect,
        setIsCorrect
    ] = useState(false);


    const [
        isIncorrect,
        setIsIncorrect
    ] = useState(false);


    // =========================================================
    // ERRORES
    // =========================================================

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    // =========================================================
    // TIEMPOS
    // =========================================================

    const tiemposRef =
        useRef([
            0,
            0,
            0,
            0,
            0
        ]);


    const inicioTiempoRef =
        useRef(null);


    // =========================================================
    // REDUX
    // =========================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const informacion =
        useSelector(
            state =>
                state.informacion.info_DB
        );


    const lista_usada =
        useSelector(
            state =>
                state.informacion.lista_usada
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================
    // SONIDOS
    // =========================================================

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // =========================================================
    // CONFIGURACIÓN INICIAL
    // =========================================================

    useEffect(() => {

        dispatch(
            setearEjercicioAction(
                'LEN40'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'lenguaje/inferencia/'
            )
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================
    // CARGAR EJERCICIO ACTUAL
    // =========================================================

    useEffect(() => {

        if (
            !Array.isArray(
                informacion
            ) ||
            informacion.length === 0
        ) {

            return;
        }


        setIndexes(
            informacion.length
        );


        const actual =
            informacion[
                count - 1
            ];


        if (!actual) {

            return;
        }


        setComparar(
            actual
        );


        // respuesta_1 siempre es correcta.
        // Mezclamos las posiciones visuales.

        const nuevasOpciones =
            mezclarOpciones([
                {
                    texto:
                        actual.respuesta_1,
                    correcta:
                        true
                },
                {
                    texto:
                        actual.respuesta_2,
                    correcta:
                        false
                },
                {
                    texto:
                        actual.respuesta_3,
                    correcta:
                        false
                }
            ]);


        setOpciones(
            nuevasOpciones
        );


        setSeleccionada(
            null
        );


    }, [
        informacion,
        count
    ]);


    // =========================================================
    // INICIAR TIEMPO
    // =========================================================

    useEffect(() => {

        if (
            iniciar &&
            comparar
        ) {

            inicioTiempoRef.current =
                Date.now();
        }


    }, [
        iniciar,
        comparar
    ]);


    // =========================================================
    // REGISTRAR TIEMPO
    // =========================================================

    const registrarTiempoActual = () => {

        if (
            inicioTiempoRef.current === null
        ) {

            return;
        }


        const ahora =
            Date.now();


        const segundos =
            (
                ahora -
                inicioTiempoRef.current
            ) / 1000;


        const indice =
            count - 1;


        tiemposRef.current[
            indice
        ] += segundos;


        inicioTiempoRef.current =
            null;
    };


    // =========================================================
    // ELEGIR RESPUESTA
    // =========================================================

    const elegirRespuesta = (
        e,
        opcion,
        indice
    ) => {

        e.preventDefault();


        if (
            disable ||
            !comparar
        ) {

            return;
        }


        setSeleccionada(
            indice
        );


        // =====================================================
        // CORRECTA
        // =====================================================

        if (
            opcion.correcta
        ) {

            setDisable(
                true
            );


            registrarTiempoActual();


            setIsCorrect(
                true
            );


            GoodWork();


            setTimeout(() => {

                setIsCorrect(
                    false
                );

            }, 300);


            // ---------------------------------------------
            // HAY MÁS EJERCICIOS
            // ---------------------------------------------

            if (
                count < indexes
            ) {

                setTimeout(() => {

                    setSeleccionada(
                        null
                    );


                    setCount(
                        count + 1
                    );


                    setDisable(
                        false
                    );

                }, 1000);

            }


            // ---------------------------------------------
            // ÚLTIMO EJERCICIO
            // ---------------------------------------------

            else {

                setTimeout(() => {

                    dispatch(
                        finalizarEjercicioAction()
                    );

                }, 1000);
            }


            return;
        }


        // =====================================================
        // INCORRECTA
        // =====================================================

        setDisable(
            true
        );


        setIsIncorrect(
            true
        );


        setContarErrores(
            contarErrores + 1
        );


        TryAgain();


        setTimeout(() => {

            setIsIncorrect(
                false
            );

        }, 300);


        setTimeout(() => {

            setSeleccionada(
                null
            );


            setDisable(
                false
            );

        }, 800);
    };


    // =========================================================
    // GUARDAR RESULTADO
    // =========================================================

    useEffect(() => {

        if (!finalizar) {

            return;
        }


        const tiempoFinal =
            tiemposRef.current.map(
                tiempo =>
                    Math.round(
                        tiempo * 10
                    ) / 10
            );


        const informacionGuardar = {

            config,

            payload: {

                ejercicio:
                    'LEN40',

                errores:
                    contarErrores,

                tiempo:
                    tiempoFinal,

                id_paciente,

                lista_usada,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacionGuardar
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <Fragment>


            <HeaderEjercicios
                estrellas={true}
                carrito={true}
            />


            {
                iniciar

                    ? (

                        <PantallaInferencia>


                            <ContenidoLEN40>


                                <ContainerFlex
                                    width="100%"
                                    display="flex"
                                    justify="center"
                                    align="center"
                                    isCorrect={
                                        isCorrect
                                    }
                                    isIncorrect={
                                        isIncorrect
                                    }
                                    $mantengoMay={
                                        true
                                    }
                                >


                                    {
                                        comparar && (

                                            <MixtaLEN40>


                                                {/* ======================= */}
                                                {/* IMAGEN                  */}
                                                {/* ======================= */}

                                                <ImagenLEN40>

                                                    {
                                                        comparar.imagen_url_1 && (

                                                            <img
                                                                src={
                                                                    `/img/${comparar.imagen_url_1}.png`
                                                                }
                                                                alt=""
                                                            />

                                                        )
                                                    }

                                                </ImagenLEN40>


                                                {/* ======================= */}
                                                {/* TEXTO Y RESPUESTAS      */}
                                                {/* ======================= */}

                                                <DerechaLEN40>


                                                    <FraseLEN40>

                                                        {
                                                            comparar.frase
                                                        }

                                                    </FraseLEN40>


                                                    <PreguntaTextoLEN40>

                                                        {
                                                            comparar.pregunta
                                                        }

                                                    </PreguntaTextoLEN40>


                                                    <RespuestasLEN40>


                                                        {
                                                            opciones.map(
                                                                (
                                                                    opcion,
                                                                    indice
                                                                ) => (

                                                                    <RespuestaLEN40
                                                                        key={
                                                                            `${comparar.id}-${indice}`
                                                                        }
                                                                        type="button"
                                                                        disabled={
                                                                            disable
                                                                        }
                                                                        $seleccionada={
                                                                            seleccionada === indice
                                                                        }
                                                                        $correcta={
                                                                            seleccionada === indice &&
                                                                            opcion.correcta
                                                                        }
                                                                        $incorrecta={
                                                                            seleccionada === indice &&
                                                                            !opcion.correcta
                                                                        }
                                                                        onClick={
                                                                            e =>
                                                                                elegirRespuesta(
                                                                                    e,
                                                                                    opcion,
                                                                                    indice
                                                                                )
                                                                        }
                                                                    >

                                                                        {
                                                                            opcion.texto
                                                                        }

                                                                    </RespuestaLEN40>

                                                                )
                                                            )
                                                        }


                                                    </RespuestasLEN40>


                                                </DerechaLEN40>


                                            </MixtaLEN40>

                                        )
                                    }


                                </ContainerFlex>


                            </ContenidoLEN40>


                            <BottomInferencia>


                                <BotoneraBottom
                                    miniInstrucciones={
                                        miniInstrucciones
                                    }
                                />


                            </BottomInferencia>


                        </PantallaInferencia>

                    )

                    : (

                        <Instrucciones
                            instrucciones={
                                instrucciones
                            }
                        />

                    )
            }


        </Fragment>
    );
};


export default LEN40;